import React, { useState, useRef, useReducer } from "react";
import SimpleReactValidator from "simple-react-validator";
import { useHistory } from "react-router-dom";
import * as api from "./../../api/api";

//BACKDROP STYLING
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
    backgroundColor: "white",
  },
}));

const initialFormData = {
  name: "",
  email: "",
  phoneNumber: "",
  address: "",
  url: "",
};

export default function Register(props) {
  const classes = useStyles();
  const history = useHistory();
  const simpleValidator = useRef(new SimpleReactValidator());
  const [formData, setFormData] = useState(initialFormData);
  const [loader, setLoader] = useState(false);
  const [ignored, forceUpdate] = useReducer((x) => x + 1, 0);

  const handleChange = (e) => {
    const { name, value } = e.target;
    simpleValidator.current.showMessageFor(name);
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async () => {
    setLoader(true);
    const { name, phoneNumber, email, address, url } = formData;
    if (simpleValidator.current.allValid()) {
      try {
        const requestObj = {};
        requestObj.name = props.name;
        requestObj.company_name = name;
        requestObj.email_id = email;
        requestObj.mobile_no = phoneNumber;
        requestObj.url = url;
        requestObj.address = address;
        requestObj.is_active = 1;
        const response = await api.sponsorCompanyReg(requestObj, props.id);
        if (response.status === 201) {
          history.push({
            pathname: "/dashboard",
            state: { userData: response.data },
          });
        }
      } catch (e) {
        setLoader(false);
      }
    } else {
      simpleValidator.current.showMessages();
      forceUpdate();
      setLoader(false);
    }
  };

  return (
    <div>
      <h4>Company Details</h4>
      <h6 className="font-weight-light">
        Please fill up your company details. It only takes a few steps
      </h6>
      <form className="pt-3">
        <div className="form-group">
          <input
            type="text"
            className="form-control form-control-lg"
            placeholder="Name"
            name="name"
            onChange={handleChange}
            // onBlur={simpleValidator.current.showMessageFor('name')}
          />
          {simpleValidator.current.message(
            "name",
            formData.name,
            "required|alpha_space",
            { className: "text-danger" }
          )}
        </div>
        <div className="form-group">
          <input
            type="email"
            className="form-control form-control-lg"
            placeholder="Email"
            name="email"
            onChange={handleChange}
          />
          {simpleValidator.current.message(
            "email",
            formData.email,
            "required|email",
            { className: "text-danger" }
          )}
        </div>
        <div className="form-group">
          <input
            type="text"
            className="form-control form-control-lg"
            placeholder="Phone"
            name="phoneNumber"
            onChange={handleChange}
          />
          {simpleValidator.current.message(
            "phoneNumber",
            formData.phoneNumber,
            "required|phone",
            { className: "text-danger" }
          )}
        </div>
        <div className="form-group">
          <input
            type="textArea"
            className="form-control form-control-lg"
            placeholder="Address"
            name="address"
            onChange={handleChange}
          />
          {simpleValidator.current.message(
            "address",
            formData.phoneNumber,
            "required",
            { className: "text-danger" }
          )}
        </div>
        <div className="form-group">
          <input
            type="textArea"
            className="form-control form-control-lg"
            placeholder="Website"
            name="url"
            onChange={handleChange}
          />
          {simpleValidator.current.message(
            "website",
            formData.phoneNumber,
            "required",
            { className: "text-danger" }
          )}
        </div>
      </form>
      <div className="mt-3">
        <div
          className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn"
          onClick={handleSubmit}
        >
          NEXT
        </div>
      </div>
      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress />
      </Backdrop>
    </div>
  );
}
